import { formatDateFromMillis } from '@/filter/date';
import { getStatusTitle } from '@/static/fertigungsauftrag/fertigungsauftragstatus';
import { getZustand } from '@/static/fertigungsauftrag/fertigungsauftragzustand';

export const collapse = {
  key: 'collapse',
  sortable: false,
  label: '',
  tdClass: 'px-2',
  stickyColumn: true,
};
export const auftragsnummer = {
  key: 'auftragsnummer',
  sortable: true,
  label: 'Auftrag',
  sortKey: 'Auftrag',
};
export const status = {
  key: 'status',
  sortable: true,
  label: 'Status',
  sortKey: 'Status',
  formatter: (value) => getStatusTitle(value),
};
export const zustand = {
  key: 'zustand',
  sortable: true,
  label: 'Zustand',
  sortKey: 'VZ',
  formatter: (value) => getZustand(value),
  tdClass: 'text-center',
};
export const projekt = {
  key: 'projekt',
  sortable: true,
  label: 'Projekt',
  sortKey: 'Projekt',
};
export const erzeugnis = {
  key: 'erzeugnis',
  sortable: true,
  label: 'Artikelnummer',
  sortKey: 'Erzeugnis',
};
export const starttermin = {
  key: 'starttermin',
  sortable: true,
  label: 'Starttermin',
  sortKey: 'Starttermin',
  formatter: (value) => formatDateFromMillis(value),
};
export const endtermin = {
  key: 'endtermin',
  sortable: true,
  label: 'Endtermin',
  sortKey: 'Endtermin',
  formatter: (value) => formatDateFromMillis(value),
};
export const bezeichnung1 = {
  key: 'bezeichnung1',
  sortable: true,
  label: 'Bezeichnung 1',
  sortKey: 'Bezeichnung1',
};
export const bezeichnung2 = {
  key: 'bezeichnung2',
  sortable: true,
  label: 'Bezeichnung 2',
  sortKey: 'Bezeichnung2',
};
export const klassifizierung = {
  key: 'klassifizierung',
  sortable: true,
  label: 'Klassifizierung',
  sortKey: 'Klassifizierung',
};
export const teilegruppe = {
  key: 'teilegruppe',
  sortable: true,
  label: 'Teilegruppe',
  sortKey: 'Teilegruppe',
};
export const freigabestatus = {
  key: 'freigabestatus',
  sortable: true,
  label: 'Freigabestatus',
  sortKey: 'Freigabestatus',
  tdClass: 'text-center',
};
export const zeichnungsnummer = {
  key: 'zeichnungsnummer',
  sortable: true,
  label: 'Zeichnung',
  sortKey: 'Zeichnung',
};
export const zeichnungsindex = {
  key: 'zeichnungsindex',
  sortable: true,
  label: 'Index',
  sortKey: 'Index',
};
export const werkstoff = {
  key: 'werkstoff',
  sortable: true,
  label: 'Werkstoff',
  sortKey: 'Werkstoff',
};
export const mengeAuftrag = {
  key: 'menge_auftrag',
  sortable: true,
  label: 'Auftragsmenge',
  sortKey: 'MngAuftrag',
  tdClass: 'text-right',
};
export const mengeneinheit = {
  key: 'mengeneinheit',
  sortable: false,
  label: 'Einheit',
  sortKey: 'ME',
};

export const lagerPlatz = {
  key: 'lagerplatz',
  sortable: true,
  label: 'Lagerplatz',
  sortKey: 'lager.LagPlatz',
};

export const lager = {
  key: 'sperrlager',
  sortable: true,
  label: 'Sperrlager',
  sortKey: 'lager.Lag',
  tdClass: 'text-center',
};

export const anzahlTeile = {
  key: 'anzahl_teile',
  sortable: true,
  label: 'Anzahl Teile',
  sortKey: 'lager.LagBst',
};

export const standardFields = [
  collapse,
  auftragsnummer,
  status,
  zustand,
  erzeugnis,
  starttermin,
  endtermin,
  bezeichnung1,
  bezeichnung2,
  teilegruppe,
  freigabestatus,
  zeichnungsnummer,
  zeichnungsindex,
];

export default [
  collapse,
  auftragsnummer,
  status,
  zustand,
  projekt,
  erzeugnis,
  starttermin,
  endtermin,
  bezeichnung1,
  bezeichnung2,
  klassifizierung,
  teilegruppe,
  freigabestatus,
  zeichnungsnummer,
  zeichnungsindex,
  werkstoff,
  mengeAuftrag,
  mengeneinheit,
  lagerPlatz,
  lager,
  anzahlTeile,
];
